<template>
  <div class="header">
    <div class="header_main">
      <img src="@/assets/images/logo_w.png" width="43%" alt="舟山市龙山船厂有限公司">
      <img src="@/assets/images/ico_nav.png" width="30" @click="is_show_nav = !is_show_nav">
    </div>

    <div class="header_nav" :class="is_show_nav?'slideDown':''" v-if="is_show_nav">
      <div class="nav_item" @click="goUrl(item.href)" v-for="(item,index) in menu_list" :key="index">
        {{item.title}}
      </div>

      <!--
      <div class="nav_item" @click="goUrl('about')">
        {{language == 'EN'?'About Us':'关于我们'}}
      </div>
      <div class="nav_item" @click="goUrl('news')">
        {{language == 'EN'?'News Center':'新闻中心'}}
      </div>
      <div class="nav_item" @click="goUrl('business')">
        {{language == 'EN'?'Business':'经营领域'}}
      </div>
      <div class="nav_item" @click="goUrl('facilities')">
        {{language == 'EN'?'Facilities':'设施设备'}}
      </div>
      <div class="nav_item" @click="goUrl('resources')">
        {{language == 'EN'?'Join Us':'人力资源'}}
      </div>
      <div class="nav_item" @click="goUrl('contact')">
        {{language == 'EN'?'Contact':'联系我们'}}
      </div>
      -->
      <div class="nav_item flex flexc">
        语言版本：
        <div class="fwhite mr15" @click="setLan('EN')">English</div>
        <div class="fwhite" @click="setLan('CH')">简体中文</div>
      </div>
    </div>

  </div>
</template>

<script>
import {getMenu} from "@/request/api";
export default {
  name: 'Header',
  data () {
    return {
      language:localStorage.getItem('language') || 'CH',
      is_show_nav:false,
      menu_list:[],
    }
  },
  created (){
    this.getMenu()
  },
  methods:{
    getMenu(){
      var that = this
      getMenu().then(res=>{
        that.menu_list = res.data.menu
      }).catch(function (error) {
          console.log(error);
      });
    },
    goUrl(url){
      this.$router.push({ path: '/mobile/'+url });
    },
    setLan(lan){
      this.language = lan
      this.is_show_lan = false
      localStorage.setItem('language',lan)
      window.location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position: fixed;
  -webkit-position: fixed;
  top:0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: rgba(11, 33, 67, .7);
  z-index: 9999;
  -webkit-z-index: 9999;
}
.header_main{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  color:#fff;
  padding: 0 15px;
  box-sizing: border-box;
}

.slideDown{
  animation: mymove 0.3s infinite;
  animation-iteration-count: 1;
}

@keyframes mymove {
  from {
    height: 0px;
  }
  to {
    height: 368px;
  }
}

.header_nav{
  font-size: 14px;
  -webkit-font-size: 14px;
  font-weight: 400;
  background-color: rgba(11, 33, 67, .7);
}
.header_nav .nav_item{
  color:#fff;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-bottom: 1px solid #E4E4E4;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderM.vue